import { Button } from "antd";
import { useSelector } from "react-redux";

const EmployeeAppraisalCard = ({
  item,
  handleView,
  reviewType,
  handelRevisedIncrement,
}: {
  item: any;
  handleView: (item: any, id: any) => void;
  reviewType: string | null;
  handelRevisedIncrement?: any
}) => {
  const regular = useSelector((state: any) => state?.eventData?.particularEmployeeDetails);
  const dateConvertion = (date: any) => {
    let spliteValue = date.split('T')[0];
    let value = spliteValue;
    let dateValue = value.split('-')
    return dateValue[2] + '-' + dateValue[1] + '-' + dateValue[0];
  }
  const employeePermission = useSelector((state: any) => state?.employeePermissionSlice?.employeePermission)
  return (

    <div
      key={item?.employeeReviewId}
      className="employee-appraisal-card cursor-pointer flex w-[100%]  justify-between items-center font-rubik"

    >
      <div className=" w-[100%]" onClick={() => handleView(item, item?.employeeReviewId)}>
        <p className="employee-appraisal-title font-rubik">{item?.reviewFormName}</p>
        <div className="flex justify-between">
          <div className="grid-rows-5 grid-flow-col gap-3 flex asset-header pt-3" >
            {item?.reviewedOn !== null ? (
              <div className="header-status header-border flex flex-col md:flex-row">
                Review date:

                <span className="pl-1">
                  {item?.reviewedOn !== null ? dateConvertion(item?.reviewedOn) : "-"}
                </span>
              </div>
            ) : (
              <div className="header-status header-border font-rubik flex flex-col md:flex-row">
                Probation Extension end date:
                <span className="pl-1">
                  {item?.nextProbationEndDate !== null
                    ? dateConvertion(item?.nextProbationEndDate)
                    : "-"}
                </span>
              </div>
            )}
            <div className={`header-status font-rubik flex flex-col md:flex-row ${item?.reviewStatus !== "Completed" && "header-border"}`}>
              Review Status: <span className="pl-1">{item?.reviewStatus}</span>
            </div>
            {item?.type !== "Probation" &&
              item?.type !== "Probation Extension" &&
              item?.reviewStatus !== "Completed" &&
              reviewType !== null && (
                <div className="header-status font-rubik">
                  Eligible for Increment:
                  <span className="pl-1" >
                    {item?.eligibleForIncrement === false ||
                      item?.eligibleForIncrement === null
                      ? "No"
                      : "Yes"}
                  </span>
                </div>
              )}
            {
              item?.incrementStatus && !employeePermission && <div className="header-status">
                Increment Status: <span className="capitalize pl-1">{item?.incrementStatus}</span>
              </div>
            }

          </div>
        </div>
      </div>

      {!employeePermission &&
        item?.reviewStatus === "Completed" && (
          <>
            {
              regular?.employeeType?.typeofEmployment === "Regular" && <>
                {item?.incrementStatus === "rejected" && (
                  <div className="">
                    <Button
                      type="primary"
                      shape="round"
                      onClick={() => handelRevisedIncrement(item)}
                      className="employee-proposal-btn"
                    >
                      Resubmit Increment
                    </Button>
                  </div>
                )}
              </>
            }

          </>
        )
      }
    </div>
  );
};
export default EmployeeAppraisalCard